<template>
  <div>
    <ml-header title="我的关注" :dark="true" />
    <div class="attention-container">
      <ul>
        <li
          v-for="goddess in goddesses"
          :key="goddess.id"
          @click="navigateTo(goddess)"
        >
          <img class="avatar" :src="goddess.avatar" alt="" />
          <p>{{ goddess.nickname }}</p>
          <img class="sex" src="../../assets/personal/female@2x.png" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getFollowList } from "@/api/user";

export default {
  name: "MyAttention",
  data() {
    return {
      goddesses: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const responseData = await getFollowList();
      this.goddesses = responseData.content;
    },
    navigateTo({ id }) {
      this.$router.push({ name: "personalHome", params: { id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.attention-container {
  margin-top: 40px;
  padding: 10px 15px;
  text-align: left;
  ul {
    li {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .avatar {
        border-radius: 50%;
        width: 34px;
        height: 34px;
      }
      p {
        margin: 0 7px 0 10px;
      }
      .sex {
        width: 11px;
        height: 14px;
      }
    }
  }
}
</style>
